import { defineComponent, inject, provide, openBlock, createElementBlock, renderSlot } from 'vue';
import { UiRadioGroupPropsOption, UiRadioGroupEmits, UiRadioGroupInjectionKey } from './index.mjs';
import { UiFormEmitterKey } from '../../../constants/index.mjs';

const _hoisted_1 = { class: "ui-radio-group" };
const __default__ = defineComponent({ name: "UiRadioGroup" });
var _sfc_main = /* @__PURE__ */ defineComponent({
  ...__default__,
  props: UiRadioGroupPropsOption,
  emits: UiRadioGroupEmits,
  setup(__props, { emit: __emit }) {
    const define = __props;
    const emits = __emit;
    const emitter = inject(UiFormEmitterKey, void 0);
    provide(UiRadioGroupInjectionKey, {
      define,
      change: (value) => {
        emits("update:modelValue", value);
        emits("change");
        emitter == null ? void 0 : emitter.emit(define.name || "", "change");
      }
    });
    ;
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1, [
        renderSlot(_ctx.$slots, "default")
      ]);
    };
  }
});

export { _sfc_main as default };
//# sourceMappingURL=index.vue2.mjs.map
